<template>
  <x-page title="店铺基础设置" :loading="loading" white-background>
    <template v-if="!loading">
      <div
        :class="[
          _._hairline,
          _['pad-both'],
          _['fontSize-16'],
          _['form-content'],
        ]"
      >
        <div :class="[_['pad-up-down'], _['flex-center']]">
          <div>是否自动接单</div>
          <div :class="_['radio-spacing']">
            <van-radio-group v-model="autoReceive" direction="horizontal">
              <van-radio :class="[_['spacing-right']]" :name="true"
                >是
                <template #icon="props">
                  <img
                    class="img-icon"
                    :src="props.checked ? activeIcon : inactiveIcon"
                  />
                </template>
              </van-radio>
              <van-radio :name="false"
                >否
                <template #icon="props">
                  <img
                    class="img-icon"
                    :src="props.checked ? activeIcon : inactiveIcon"
                  />
                </template>
              </van-radio>
            </van-radio-group>
          </div>
        </div>
        <div :class="[_._hairlineTop]">
          <div :class="[_['pad-top-down']]">商家公告</div>
          <van-field
            v-model="notice"
            :class="_.field"
            autosize
            type="textarea"
            maxlength="100"
            placeholder="请填写..."
            show-word-limit
          />
          <p :class="_.tip">商家公告需在后台开启公告展示才可在店铺主页展示</p>
        </div>
      </div>
      <div :class="_['submit-btn']">
        <van-button
          v-track="{
            name: '店铺设置-提交',
            id: 'cl9qg095x001qkcug49ivfwue',
          }"
          :class="_.btn"
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          block
          @click="submitConfig"
          >提交</van-button
        >
      </div>
    </template>
  </x-page>
</template>

<script>
  import activeImg from './images/选中.png'
  import inactiveImg from './images/未选中.png'
  import Vue from 'vue'
  import {
    apiOrderMerchantGetConfig,
    apiOrderMerchantUpdateConfig,
  } from '@/api'
  import { Toast } from 'vant'
  import { Track } from '@/utils/Track'
  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '店铺基础设置',
      })),
    ],
    data() {
      return {
        notice: '',
        activeIcon: activeImg,
        inactiveIcon: inactiveImg,
        autoReceive: true,
      }
    },

    computed: {
      loading() {
        return false
      },
    },

    mounted() {
      this.getConfig()
      //
    },
    methods: {
      //获取基础设置
      async getConfig() {
        const result = await apiOrderMerchantGetConfig(
          {},
          {
            hasStoreCode: true,
          },
        )
        console.log('result---->', result)
        if (result) {
          this.autoReceive = result.autoReceive
          this.notice = result.notice
        }
      },
      //提交
      async submitConfig() {
        Toast.loading({
          message: '提交中',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
        })
        await apiOrderMerchantUpdateConfig(
          {
            autoReceive: this.autoReceive,
            notice: this.notice,
          },
          {
            hasStoreCode: true,
          },
        )
        Toast.clear()
        Toast.success('修改成功')
        this.$router.go(-1)
      },
    },
  })
</script>

<style lang="scss" module>
  .pad-both {
    padding: 0 12px 0 12px;
  }
  .pad-up-down {
    padding: 16px 0 16px 0;
  }

  .fontSize-16 {
    font-size: 16px;
  }
  .pad-top-down {
    padding: 16px 0 8px 0;
  }
  .tip {
    font-size: 12px;
    margin-top: 12px;
    font-weight: 400;
    color: #999999;
  }
  .flex-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .form-content {
    height: calc(100% - 60px);
  }
  .radio-spacing {
    .spacing-right {
      margin-right: 32px;
    }
  }
  .field {
    background-color: #f6f8fa !important;
    border-radius: 4px !important;
  }
  .submit-btn {
    width: 100%;
    height: 60px;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      width: 351px;
      height: 44px;
      border-radius: 22px;
    }
  }
</style>
